import { render, staticRenderFns } from "./coach_vip.vue?vue&type=template&id=1f7c8ab0&scoped=true&"
import script from "./coach_vip.vue?vue&type=script&lang=js&"
export * from "./coach_vip.vue?vue&type=script&lang=js&"
import style0 from "./coach_vip.vue?vue&type=style&index=0&id=1f7c8ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7c8ab0",
  null
  
)

export default component.exports